import { DarkEditIcon, DeleteIcon } from '../Icons/CommonIcons';
import { GamePack, Organization } from '@/API';

interface GamePackCardPrompts {
  gamePack: GamePack;
  onEdit?: () => void;
  onDelete?: () => void;
  onClick?: () => void;
  isHighlighted: boolean;
  hideOrgs?: boolean;
  hideButtons?: boolean;
}

const formatOrgs = (orgs: Organization[]) => {
  if (!orgs || orgs.length === 0) {
    return 'All';
  }
  if (orgs.length > 3) {
    return `${orgs[0]?.name}, ${orgs[1]?.name}, and ${orgs.length - 2} others`;
  } else {
    return orgs
      .map((o) => o?.name)
      .filter((o) => o !== undefined && o.length > 0)
      .join(', ');
  }
};

export function GamePackCard({
  gamePack,
  onEdit,
  onDelete,
  onClick,
  isHighlighted,
  hideOrgs,
  hideButtons
}: GamePackCardPrompts) {
  return (
    <div
      className={`flex w-full bg-gray-100 card p-[24px] rounded-[20px] border-2 hover:border-clementine-dark group hover:cursor-pointer gamepack-card ${
        isHighlighted ? 'border-black-dark bg-orange-100' : ''
      }`}
      onClick={() => onClick?.()}
    >
      <div className="flex flex-col w-full h-full">
        <div className="flex flex-row items-center justify-between mb-[8px] h-34">
          <div className="flex flex-row">
            <h2>{gamePack.name}</h2>
          </div>
          <div className="flex flex-row items-center hidden group-hover:flex">
            {hideButtons ? (
              <></>
            ) : (
              <>
                <span
                  className="hover:cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    onEdit?.();
                  }}
                >
                  <DarkEditIcon />
                </span>
                <span
                  className="ml-[16px] hover:cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete?.();
                  }}
                >
                  <DeleteIcon />
                </span>
              </>
            )}
          </div>
        </div>
        <p className="flex card-body flex-grow mb-[24px]">{gamePack.description}</p>
        <div className="card-footer flex flex-col w-full mt-auto">
          <div className="flex flex-row mb-[8px]">
            <div className="vertical-divider"></div>
            <p>{gamePack.prompts?.length ?? '0'} Prompts</p>
          </div>
          <div className="border-t-2  border-gray-300 my-8"></div>
          <div className="flex flex-row items-center">
            <span className="py-4 rounded-full text-sm">
              Status:{' '}
              <span className={'text-sm'}>
                {(gamePack as any).status === 'ACTIVE' ? 'Active' : 'Disabled'}
              </span>
            </span>
            {hideOrgs !== true && (
              <>
                <span className="text-gray-400 mx-4">|</span>
                <span className="py-4 rounded-full text-sm">
                  Access: {formatOrgs(gamePack.organizations ?? [])}
                </span>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
